import React from 'react'
import Layout from '../components/layout'
import { StaticImage } from "gatsby-plugin-image"

const Success = () => {
    const script = `
        <script type="text/javascript">
        _linkedin_partner_id = "6150417";
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(_linkedin_partner_id);
        </script><script type="text/javascript">
        (function(l) {
        if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
        window.lintrk.q=[]}
        var s = document.getElementsByTagName("script")[0];
        var b = document.createElement("script");
        b.type = "text/javascript";b.async = true;
        b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
        s.parentNode.insertBefore(b, s);})(window.lintrk);
        </script>
        <noscript>
        <img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=6150417&fmt=gif" />
        </noscript>
    `
    return (
        <Layout>
            <div dangerouslySetInnerHTML={{ __html: script }}>
            </div>
            <section className='py-28 lg:py-44 lg:max-w-[1440px] mx-auto px-6 text-[#4F4F4F]'>
                <div className='grid gap-3 lg:grid-cols-2 lg:ml-[8%] mx-[5%] lg:mx-0'>
                    <div className='my-auto'>
                        <h2 className='text-4xl lg:text-7xl font-bold'>Thank you for your response!</h2>
                        <p className='mt-11 text-lg lg:text-2xl font-medium'>Our sales team would reach out to you shortly.</p>
                    </div>
                    <StaticImage
                        src="../images/success.png"
                        alt='thank you'
                        placeholder="blurred"
                        quality="100"
                    />
                </div>
            </section>
        </Layout>
    )
}

export default Success